import Colors from '../../../../shared/assets/style/default/color';
import Fonts from '../../../../shared/assets/style/default/fonts';
import Screen from '../../../../shared/utils/screen';
import styled from 'styled-components';
import withClock from '../../../../shared/components/utils/hoc/withClock';

const TopBarClock = styled.span<React.CSSProperties>`
  align-items: center;
  color: ${Colors['text']};
  display: flex;
  font-family: ${Fonts['regular']};
  font-size: ${32 * Screen.widthRatio}px;
`;

export default withClock(TopBarClock, {
  displaySeconds: false,
  displayDay: true,
  displayDayOfWeek: true,
  displayMonth: true,
  displayMonthPreposition: true,
});
